import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ExtraSeatsRequested } from '../../../ampli';
import { selectSelectedSchoolId } from '../../../reducers/user.selectors';
import services from '../../../services';
import schoolService from '../../../services/school.service';
import { SnackbarContext } from '../../../state/SnackbarContextProvider';

export const useRequestMoreSeats = () => {
	const { t } = useTranslation();
	const { openSnackbar } = useContext(SnackbarContext);
	const schoolSeats = useSelector((state: any) => state.user.schoolSeats);
	const selectedSchoolId = useSelector(selectSelectedSchoolId);

	const showError = (message: string) => {
		openSnackbar({
			type: 'error',
			message,
		});
	};

	const showInfo = (message: string) => {
		openSnackbar({
			type: 'success',
			message,
		});
	};

	const handleRequestMoreSeats = async (seatsCount?: number) => {
		const errorMessage = t(
			'There was an error sending your request. Please try again later, or contact support schulen@meinunterricht.de'
		);

		try {
			if (!selectedSchoolId) {
				showError(errorMessage);
				return;
			}

			if (schoolSeats) {
				const totalSeats: number =
					schoolSeats.bibliothekSeats.available +
					schoolSeats.courseSeats.available +
					schoolSeats.kombiSeats.available;

				services.track.ampliEventTrack({
					event: new ExtraSeatsRequested({
						'school id': selectedSchoolId,
						'current total seats': totalSeats,
					}),
				});
			}

			const payload: any = { schoolId: selectedSchoolId };
			if (seatsCount) {
				payload.seatsCount = seatsCount;
			}

			const result = await schoolService.requestMoreSeats(payload);

			if (result?.success) {
				showInfo(t('The contact person from meinUnterricht will get in touch shortly.'));
			} else {
				showError(errorMessage);
			}
		} catch {
			showError(errorMessage);
		}
	};

	return {
		handleRequestMoreSeats,
	};
};
